// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nNDkI","upload":"styles_upload__Z5sgb","fileTitle":"styles_fileTitle__4y6dr","fileFormat":"styles_fileFormat__nokT8"};